module.exports = new __parcel__URL__("bird01.cdbcd0eb.mp3").toString();